// make sure to install `history` https://github.com/remix-run/history/blob/main/docs/installation.md
import { createBrowserHistory } from "history"

export const GlobalHistory = createBrowserHistory({ window })
